var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"v-model":_vm.value,"rotate":360,"size":100,"width":10,"color":"secondary"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(_vm._s(_vm.value)+" %")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }